// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__5MnZL","button":"Slider_button__zqyxP","active":"Slider_active__o+JsT"};